import {
    DriveFileRenameOutline as IconArea,
    Nature as IconFunction,
    EditLocation as IconObservation,
    Category as IconOther,
} from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { SelectableButton } from "~/modules/app/components/SelectableButton";

import { FeatureCreateOptionDraft } from "../../hooks/useDraftSelectedOption";

export function DrawTypeSection({
    selectedDrawType,
    onDrawTypeSelect,
    allowedDrawTypes = ["area", "observation", "ecologicalFunction", "other"],
}: {
    selectedDrawType?: FeatureCreateOptionDraft["type"];
    onDrawTypeSelect: (newDrawType: "area" | "observation" | "ecologicalFunction" | "other") => void;
    allowedDrawTypes?: Array<"area" | "observation" | "ecologicalFunction" | "other">;
}) {
    const { t } = useTranslation("mapEditor");

    const options: Array<{
        key: "area" | "observation" | "ecologicalFunction" | "other";
        icon: React.ReactElement;
        label: string;
    }> = [
        {
            key: "area",
            icon: <IconArea fontSize="large" />,
            label: t("mapEditorFeatureCreateDialog.drawTypeSection.labelDrawArea"),
        },
        {
            key: "other",
            icon: <IconOther fontSize="large" />,
            label: t("mapEditorFeatureCreateDialog.drawTypeSection.labelDrawOther"),
        },
        {
            key: "observation",
            icon: <IconObservation fontSize="large" />,
            label: t("mapEditorFeatureCreateDialog.drawTypeSection.labelAddObservation"),
        },
        {
            key: "ecologicalFunction",
            icon: <IconFunction fontSize="large" />,
            label: t("mapEditorFeatureCreateDialog.drawTypeSection.labelAddFunction"),
        },
    ];

    return (
        <Stack paddingBlock={2} rowGap={1}>
            <Typography variant="subtitle2">{t("mapEditorFeatureCreateDialog.drawTypeSection.title")}</Typography>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 1,
                }}
            >
                {options
                    .filter(option => allowedDrawTypes.includes(option.key))
                    .map(({ key, icon, label }) => (
                        <SelectableButton
                            key={key}
                            onClick={() => onDrawTypeSelect(key)}
                            selected={selectedDrawType === key}
                            sx={{ alignItems: "center", display: "flex", flexDirection: "column", rowGap: 1 }}
                        >
                            {icon}
                            <Typography>{label}</Typography>
                        </SelectableButton>
                    ))}
            </Box>
        </Stack>
    );
}
